import { jsonp, ajax } from '@ifeng-fe/ui_base';

// apiUrl为webpack注入的全局变量
/* eslint-disable */
const apiBaseUrl = apiUrl;

// 获取调查数据
export const getSurveyData = async id => {
    return await jsonp('//sv.ifeng.com/index.php/survey/getdata', {
        data: {
            id,
        },
        jsonpCallback: 'getSurveyData',
        cache: false,
    });
};

// 提交调查数据
export const postSurveyData = async (param, id) => {
    return await jsonp(`//sv.ifeng.com/index.php/survey/postsurvey?${param}`, {
        data: {
            id,
            act: 'postsurvey',
            surid: id,
            ref: window.location.href,
        },
        jsonpCallback: 'postSurveyData',
        cache: false,
    });
};

export const getDocData = async id => {
    return await jsonp(`${apiBaseUrl}/getDocData/${id}/getDocData`, {
        jsonpCallback: 'getDocData',
        cache: false,
    });
};

export const getAwardsList = async id => {
    const res = await jsonp(`https://shankapi.ifeng.com/feedflow/coopdoc/${id}/info/getAwardsList`, {
        jsonpCallback: 'getAwardsList',
        cache: false,
    });

    return res.data;
};
